export default __webpack_public_path__ + "static/1509-a83157f1cd2eb7cdeaea6c727f3853b2.gif";